const generateNameForOption = (obj) => {
    return parseFloat(obj.price) !== 0
        ? `${obj.displayName} +$${obj.price} per side`
        : obj.displayName;
};

export default generateNameForOption;
